/**
 * header-search.js
 * ------------------------------------------------------------------
 * Header search boxes (desktop + mobile), Shopify native search.
 * The form itself does the search: typing + Enter opens /search?q=...&type=product
 * This script only adds two small comforts:
 *   - the "x" button appears when there is text and clears the box
 *   - an empty search is not submitted
 *
 * Markup: snippets/header-search-desktop.liquid, snippets/header-search-mobile.liquid
 */

const HEADER_SEARCH_SELECTORS = {
  form: '[data-header-search-form]',
  input: '[data-header-search-input]',
  clearButton: '[data-header-search-clear]',
};

/**
 * @param {HTMLFormElement} searchForm
 */
function initHeaderSearch(searchForm) {
  const searchInput = searchForm.querySelector(HEADER_SEARCH_SELECTORS.input);
  const clearButton = searchForm.querySelector(HEADER_SEARCH_SELECTORS.clearButton);

  if (!searchInput) {
    console.warn('[header-search] Search form without [data-header-search-input], skipping it.', searchForm);
    return;
  }

  const hasSearchText = () => searchInput.value.trim() !== '';

  const updateClearButton = () => {
    if (clearButton) clearButton.hidden = !hasSearchText();
  };

  searchInput.addEventListener('input', updateClearButton);

  if (clearButton) {
    clearButton.addEventListener('click', () => {
      searchInput.value = '';
      updateClearButton();
      searchInput.focus();
    });
  }

  searchForm.addEventListener('submit', (event) => {
    if (!hasSearchText()) {
      event.preventDefault();
      searchInput.focus();
    }
  });

  updateClearButton();
}

document.querySelectorAll(HEADER_SEARCH_SELECTORS.form).forEach((searchForm) => {
  try {
    initHeaderSearch(searchForm);
  } catch (error) {
    // The form still works without this script (plain HTML form submit).
    console.error('[header-search] Could not start the header search box.', error);
  }
});
